
	import { SuggestedProducts } from "@/service/suggested-products";
	import Vue from "vue";
  import ProductShelf from '@/components/v2/product-list/ProductShelf.vue';

	export default Vue.extend({
		name: "SuggestedProducts",
		components: {
			"product-shelf": ProductShelf
		},
    props: {
      amount: {
          type: Number,
          required: false,
          default: 3
      },
    },
		data() {
			return <{
				productKeys: string[] | null
			}>{
				productKeys: null
			};
		},
		mounted() {
			this.refresh();
		},
		methods: {
			refresh() {
				this.refreshSuggestedProducts();
			},

			refreshSuggestedProducts() {
				SuggestedProducts.getInstance().getSuggestedProductKeys(this.amount)
					.then(productKeys => {
						this.productKeys = productKeys.slice(0, this.amount);
					});
			}
		}
	});
